import styled from "styled-components";

export default styled.div`
  background-color: #eee;
  border: 1px solid black;
`;
